import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { getItemFromStorageSimple, RECENT_CASES_STORAGE_UPDATED } from "../lib/script";
import {
    recentCaseHref,
    recentCasePersonNumber,
} from "../lib/recentCasesNav";
import { formatPatientName } from "../lib/patientName";

function normalizeRecentCasesPayload(raw) {
    if (!raw || raw.errorMessage) {
        return []
    }
    if (Array.isArray(raw)) {
        return raw
    }
    if (Array.isArray(raw.data)) {
        return raw.data
    }
    if (Array.isArray(raw.recent_cases)) {
        return raw.recent_cases
    }
    if (Array.isArray(raw.cases)) {
        return raw.cases
    }
    return []
}

export default function RecentCases({classes}) {
    const [, setRecentCasesRevision] = useState(0)

    useEffect(() => {
        const onUpdated = () => setRecentCasesRevision((v) => v + 1)
        window.addEventListener(RECENT_CASES_STORAGE_UPDATED, onUpdated)
        return () => window.removeEventListener(RECENT_CASES_STORAGE_UPDATED, onUpdated)
    }, [])

    const fromApi = getItemFromStorageSimple('recentCases')
    const lastactiveCases = normalizeRecentCasesPayload(fromApi)

    const firstRecent = lastactiveCases?.[0]
    const firstPersonNumber = firstRecent ? recentCasePersonNumber(firstRecent) : null
    const recentPatientsTo = firstPersonNumber
        ? recentCaseHref(firstPersonNumber, firstRecent)
        : '/cases'

    return <>
        {lastactiveCases && lastactiveCases.length > 0 && <li className={classes.link_patient}>
            <NavLink to={recentPatientsTo} className={({ isActive }) => isActive ? classes.link_active : "" }>
                <i className="ti ti-user-circle"></i>Recent Patients
            </NavLink>
            <div className={classes.modal_last_cases}>
                <div className={classes.sub_menu}>
                    {lastactiveCases.slice(0, 5).map(item => {
                        const personNumber = recentCasePersonNumber(item)
                        const label =
                            item.name ??
                            (item.first_name || item.last_name || item.suffix
                                ? formatPatientName(item)
                                : null)
                        const rowKey = item.id ?? item.case_id ?? personNumber
                        if (!personNumber) {
                            return (
                                <div key={rowKey}>
                                    {label || '—'}
                                </div>
                            )
                        }
                        return (
                            <div key={rowKey}>
                                <Link to={recentCaseHref(personNumber, item)}>{label}</Link>
                            </div>
                        )
                    })}
                </div>
            </div>
        </li>}
    </>
}
